import Vue from 'vue';
export const classToPositiveNumber = Vue.extend({
    computed: {
        classToPositiveNumber() {
            return (num) => {
                let result = '';
                if (num.isGreaterThan(0))
                    result = 'positive';
                if (num.isNegative())
                    result = 'negative';
                return result;
            };
        }
    }
});
